import { render, staticRenderFns } from "./orderSidebar.vue?vue&type=template&id=331f9fd8&lang=pug"
import script from "./orderSidebar.vue?vue&type=script&lang=js"
export * from "./orderSidebar.vue?vue&type=script&lang=js"
import style0 from "./orderSidebar.vue?vue&type=style&index=0&id=331f9fd8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports